import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ServerBaseService } from '../server-base.service';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';

const STORAGE_KEY = 'app_notes_v1';

@Injectable()
export class NoteService extends ServerBaseService {

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl);
  }

  public add(tableName: string, tableId: number, message: string): void {
    this.request<any>('POST', 'Note/Add', undefined, { tableName, tableId, message }).subscribe();
  }
}
